import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from './Icon'

const SearchBox = styled.div`
  position: relative;
  height: 22px;
  /* bad */
  flex: 0 1 ${({ width }) => width || '130px'};
  ${({ alignRight }) => (alignRight ? 'margin-left: auto;' : '')}
  & > input {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0px 5px;
    border: 1px solid ${({ theme }) => theme.border1};
    background: ${({ theme }) => theme.inputBgColor};
    color: ${({ theme }) => theme.inputColor};
    outline: 0;
    border-radius: 3px;
    text-indent: 18px;
    transition: all 0.25s ease-in;
    &:focus {
      border-color: ${({ theme }) => theme.highlight};
    }
    &::-webkit-input-placeholder {
      /* stylelint-disable-line */
      font-size: 12px;
    }
  }
  & > i {
    position: absolute;
    left: 6px;
    top: 50%;
    transform: translateY(-50%);
  }
`

export default class SearchInput extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    alignRight: PropTypes.bool,
    width: PropTypes.string,
  }

  static defaultProps = {
    value: '',
    placeholder: '',
    alignRight: false,
    width: '',
    onChange: () => {},
  }

  constructor(props) {
    super(props)
    this.state = { value: props.value || '' }
  }

  _onChange = e => {
    const val = e.target.value
    const { onChange } = this.props
    this.setState({
      value: val,
    })
    onChange && onChange(val)
  }

  render() {
    const { value } = this.state
    const { alignRight, placeholder, width } = this.props
    return (
      <SearchBox alignRight={alignRight} width={width}>
        <Icon type="search" size={14} color="#48515D" />
        <input type="search" onChange={this._onChange} value={value} placeholder={placeholder} />
      </SearchBox>
    )
  }
}
